import { WidgetModel } from '@fi-app/widget/model/widget.model';
import { isDefined } from '@fi-shared/utils/is-defined';
import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';

export class FormListingWidgetModel extends WidgetModel {
    onControlInitialized(control: WidgetPlaceHolderControlModel) {
        super.onControlInitialized(control);
        if (!isDefined(control.Settings.ShowDescription)) {
            control.Settings.ShowDescription = true;
        }
    }
}
